export const BRAND = 'smartshift';
export const BRAND_PORTER = 'porter';
export const SOURCE = 'website';
export const APP_LANGUAGE = 'en';
export const COUNTRY = 'in';
